import {observable, action} from 'mobx';
import Cookies from 'universal-cookie';
// import cd from '../color-difference';
import {
    api_login,
    api_recover_password,
    api_me,
    // api_token,
    api_get_user_addresses,
    api_get_user_pickup_addresses,
    api_add_user_address,
    api_update_user_address,
    api_delete_user_address,
    api_set_default_user_address,
    api_update_user_phone,
    api_update_user,
    api_update_user_email,
    api_get_orders,
    // api_get_orders_by_shop,
    // api_get_sessione_scatti_by_projectID,
    // api_set_sessione_scatti,
    api_get_stack_by_user,
    api_get_coupon_by_user,
    // api_get_coupon_details_by_shop,
    api_get_project_merchant,
    api_get_metadata_by_projectID,

    api_search_shipments,
    api_login_as_user,
    api_health_check,

    // api_get_file_info_by_project_id_and_number_esselunga,
    // api_get_payment_result_1,
    // api_add_role,
    // api_update_role,
    // api_search_roles,
    api_search_users,
    // api_search_areas,
    // api_add_shipment,
    api_create_Coupon,
    api_get_projects_by_id,
    // api_get_projects_by_user,
    api_save_project_data,
    api_upload_excel_data,
    // api_save_url_and_language,
    api_get_project_configuration_data,
    // api_save_or_update_landing_page_data,
    api_get_data_sessione_scatti,
    api_update_download_data,
    api_get_last_data_sessione_scatti,
    api_change_landing_page_data,
    api_get_landing_page_data_by_url,
    api_delete_athlete,
    api_update_project_metadata,
    api_send_data_to_referents,
    api_save_athlete_data,
    api_save_athlete_photo,
    api_save_athlete_photo2,
    api_get_photoselfie_geturl,
    api_save_multi_athlete_data,
    // api_check_newsletter_registration,
    api_check_newsletter_registration_new,
    api_save_calendar_data,
    api_get_calendars,
    api_get_calendar_data,
    api_delete_calendar_by_id,
    api_upload_calendar_data,
    api_get_calendar_landing_page_data_by_url,
    api_upload_photo,
    api_save_edited_calendar_data,
    api_get_calendar_data_project_id_calendar_id,
    api_get_project_teams
} from '../utils/API';

import {
    LANGUAGES_COUNTRY,
    API_URL,
} from "../utils/constants";

import {toJS} from 'mobx';
// import { ObservableArray } from 'mobx/lib/internal';


const cookies = new Cookies();

export default class AppState {

    @observable user_id = cookies.get('user_id') ? cookies.get('user_id') : false;
    @observable email = cookies.get('email') ? cookies.get('email') : '';
    @observable token = cookies.get('token') ? cookies.get('token') : false;
    @observable refresh_token = cookies.get('refresh_token') ? cookies.get('refresh_token') : false;
    @observable user_roles = cookies.get('user_roles') ? cookies.get('user_roles') : false;
    @observable project_id = cookies.get('project_id') ? cookies.get('project_id') : false;
    @observable project_type = cookies.get('project_type') ? cookies.get('project_type') : false;
    @observable landing_page_status = cookies.get('landing_page_status') ? cookies.get('landing_page_status') : false;

    //Y-m-d
    @observable data_ordine_iniziale = cookies.get('data_ordine_iniziale') ? cookies.get('data_ordine_iniziale') : "";

    //
    @observable file = null;
    @observable file_name = null;
    @observable file_size = null;    
    @observable error_file_size = false;
    @observable photo_uploaded = observable.array([]);

    @observable uploadDisabled = false;
    @observable modificaDisabled = true;
    @observable execl_uploaded_with_name_and_lastname = null;
    @observable dataUploadedLength = '';
    @observable showEditableTable = null;
    @observable flagPage = 1;
    @observable flagPageSessioneScatti = 1;
    @observable dataUltimoDownload = null;
    @observable data_ordine_finale = cookies.get('data_ordine_finale') ? cookies.get('data_ordine_finale') : "";
    @observable dati_inviati_ai_referenti = false;
    @observable projectID = '';
    @observable project_name = '';
    @observable merchant_email = '';
    @observable can_manage_employee = false;
    @observable employee = 0;
    @observable areas = 1;
    @observable roles = 1;
    @observable shop_orders = 1
    @observable shipments = [];
    @observable hostname = window.location.hostname && window.location.hostname.match(/[\w]+?\.com|[\w]+?\.it/, '') ? window.location.hostname.match(/[\w]+?\.com|[\w]+?\.it/, '')[0] : false; //fix to work on akinda.it
    @observable permitted_users = false;
    @observable permitted_users_shop = false;
    @observable permitted_users_myshop = false;
    @observable permitted_users_stack = false;
    @observable permitted_users_coupon = false;
    @observable billing_form = false;
    @observable permission_orders_logs = false;
    @observable permission_add_promotions = false;
    @observable permissions = [];
    @observable currency = ' €';

    /* app variable */
    @observable users_search_results = false;
    @observable options_users_search = {page: 0, pages: 0, limit: 10, key: '', sort: false, filter: false};
    @observable users_employee_search_results = false;
    @observable options_users_employee_search = {page: 0, pages: 0, limit: 10, key: '', sort: false, filter: false};
    @observable roles_search_results = false;
    @observable shopOrders_search_results = false;
    @observable myshopOrders_search_results = false;

    @observable coupons_search_results = false;
    @observable sessione_scatti_search_results = false;
    @observable projectMetadata = [];
    @observable marginsAndRoyalties_search_results = false;
    @observable options_roles_search = {page: 0, pages: 0, limit: 1000, key: '', pagination_enabled: false};
    @observable options_shopOrders_search = {page: 0, pages: 0, limit: 1000, key: '', pagination_enabled: false};
    @observable options_margins_and_royalties_search = {
        page: 0,
        pages: 0,
        limit: 1000,
        key: '',
        pagination_enabled: false
    };

    @observable areas_search_results = false;
    @observable options_areas_search = {page: 0, pages: 0, limit: 1000, key: '', pagination_enabled: false};
    @observable permissions_search_results = false;
    @observable options_permissions_search = {page: 0, pages: 0, limit: 10, key: ''};
    @observable shipments_search_results = false;
    @observable options_shipments_search = {page: 0, pages: 0, limit: 1000, key: '', pagination_enabled: false};
    @observable promotions_search_results = false;
    @observable options_promotions_search = {page: 0, pages: 0, limit: 10, key: '', pagination_enabled: true};
    @observable orders_logs_search_results = false;
    @observable options_orders_logs_search = {page: 0, pages: 0, limit: 10, key: '', pagination_enabled: true};


    @observable project_merchant = [];
    @observable stores_search_results = [];
    @observable products_search_results = [];


    // NEW STORE
    @observable store = {domain: window.location.hostname};
    @observable all_user_data = false;
    @observable user_has_permission_to_access_ps = false;
    @observable lastLocation = false;
    @observable verified = cookies.get('verified') ? cookies.get('verified') : 0;
    // @observable shopping_cart = generate_shopping_cart(this);
    @observable addresses = {billing: [], shipment: [], pickup: []};
    @observable name = cookies.get('name') ? cookies.get('name') : false;
    @observable projectList = cookies.get('projectList') ? cookies.get('projectList') : false;

    @observable surname = cookies.get('surname') ? cookies.get('surname') : false;
    @observable phone = cookies.get('phone') ? cookies.get('phone') : false;
    @observable password_recovered = cookies.get('password_recovered') ? cookies.get('password_recovered') : 0;
    @observable user_logged = false;
    @observable products = [];
    @observable code = cookies.get('code') ? cookies.get('code') : false;
    @observable orders = false;
    @observable selected_shipment_address = cookies.get('selected_shipment_address') ? cookies.get('selected_shipment_address') : false;

    @observable selected_billing_address = cookies.get('selected_billing_address') ? cookies.get('selected_billing_address') : false;

    // @observable options_roles_search = {page:0, pages:0, limit:1000, key:'', pagination_enabled:false};

    @observable shipment_cost = cookies.get('shipment_cost') ? cookies.get('shipment_cost') : false;

    @observable shipments = [];
    @observable pickup = [];
    @observable permissions = false;
    @observable hostname = window.location.hostname && window.location.hostname.match(/[\w]+?\.com|[\w]+?\.it/, '') ? window.location.hostname.match(/[\w]+?\.com|[\w]+?\.it/, '')[0] : false; //fix to work on akinda.it
    @observable old_cookies = cookies.get('old_cookies') ? cookies.get('old_cookies') : false;
    @observable loading = false;
    @observable lang = 'it';
    @observable app_lang = null;
    @observable categories = [];
    @observable params = [];
    @observable process_type = null;
    @observable selected_calendar_data = [];
    @observable calendar_selected = false;
    @observable selected_calendar_id = '';
    @observable selected_calendar_name= '';
    @observable selected_calendar_url = '';
    @observable DEFAULT_TEXT = import(`../assets/translations/${this.lang}.json`).then((lang) => this.DEFAULT_TEXT = lang
    ).catch((error) => {
        // console.error(`"${this.lang}" not yet supported`);
    });

    //=====================================
    //======= API UTIL FUNCTIONS ==========
    //=====================================

    @action health_check(callback) {
        api_health_check(function (res) {
            if (res) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action uploadExcelData(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_upload_excel_data(data, function (res) {
            
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action updateProjectMetadata(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_update_project_metadata(data, function (res) {
            
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    /**
     * salva i dati del form di Photo Selfie
     * versione prima della modalità multipla
     * @param {*} data 
     * @param {*} callback 
     */
    @action save_athlete_data(data, callback) {

        // let self = this;
        // data['token'] = self.token;
        api_save_athlete_data(data, function (res) {
            if (callback) callback(res);
        });
    }


    /**
     * invia i dati dal form di PhotoSelfie
     * 
     * @param {*} data 
     * @param {*} callback 
     */
    @action save_multi_athlete_data(data, callback) {

        let self = this;
        data['token'] = self.token;
        
        api_save_multi_athlete_data(data, function (res) {
            if (callback) callback(res);
        });
    }

    /**
     * invia la foto appena caricate dal componente UploadPhoto() sulla pagina di photoselfie
     * 
     * @param {*} data 
     * @param {*} callback 
     */
    @action save_athlete_photo(data, callback) {
        
        api_save_athlete_photo(data, function (res) {

            if( res ) {
                if (callback) callback(res);
            } else {
                callback(false);
            }
        });
    }

    /**
     * chiamata per avere la url della foto dell'album caricat in S3
     * 
     * @param {*} data 
     * @param {*} callback 
     */
    @action get_photoselfie_geturl(data, callback) {
        
        data.token = this.token;

        api_get_photoselfie_geturl(data, function (res) {

            if( res ) {
                if (callback) callback(res);
            } else {
                callback(false);
            }
        });
    }
   
    /**
     * variante in test della save_athlete_photo2
     * chiama la versione 2 che usa un modo diverso di connettersi con il client S3
     * rifa la login prima di fare le chiamate
     * 
     * @param {*} data 
     * @param {*} callback 
     */
    @action save_athlete_photo2(data, callback) {
        
        api_save_athlete_photo2(data, function (res) {

            if( res ) {
                if (callback) callback(res);
            } else {
                callback(false);
            }
        });
    }

    @action check_newsletter_registration(params) {
        api_check_newsletter_registration_new(params);
    }

    @action deleteAthlete(data, callback) {
        
        let self = this;
        data['token'] = self.token;
        api_delete_athlete(data, function (res) {
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action saveModifiedProjectData(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_update_project_metadata(data, function (res) {
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action login(email, password, callback) {
        let self = this;
        api_login({'email': email, 'password': password}, function (res) {
            if (res.token) {
                cookies.set('email', res.email, {path: '/', domain: '.' + self.hostname});
                cookies.set('user_id', res.id, {path: '/', domain: '.' + self.hostname});
                cookies.set('refresh_token', res.refresh_token, {path: '/', domain: '.' + self.hostname});
                cookies.set('verified', res.verified, {path: '/', domain: '.' + self.hostname});
                cookies.set('token', res.token, {});
                // cookies.set('project_id', res.project_id, {});

                self.email = res.email;
                self.user_id = res.id;
                self.token = res.token;
                self.refresh_token = res.refresh_token;
                self.verified = res.verified;
                // self.project_id = res.project_id;
                // if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }

            afterLogin(res, self, callback);
        });
    }

    @action logout() {
        let copythis = this;
        copythis.loading = true;
        clearCookies(copythis);
        window.location.reload();
    }

    @action handle_app_lang(language) {
        if (language === "undefined") {
            this.lang = 'it';
            this.app_lang = 'it';
            cookies.set('app_lang', this.lang);
        } else {
            this.lang = language;
            cookies.set('app_lang', language);
        }

        import(`../assets/translations/${this.lang}.json`).then((lang) => {
            this.DEFAULT_TEXT = lang;
        }).catch((error) => {
            // console.error(`"${this.lang}" not yet supported`);
        });
    }

    @action is_user_logged(callback) {
        if (this.user_id && this.token && this.verified) {
            this.user_logged = true;
            if (callback) callback(true);
        } else {
            this.user_logged = false;
            if (callback) callback(false);
        }
    }

    @action is_user_enabled_to_merchant(callback) {
        let founded = false;
        let self = this;
        if (this.permissions) {
            this.permissions.forEach(function (permission) {
                if (permission.name === 'access_merchant') {
                    founded = true;
                }
            });
            if (callback) callback(founded);
        } else {
            self.me({permissions: 1}, function (res) {
                if (res) {
                    self.is_user_enabled_to_merchant(callback);
                } else {
                    if (callback) callback(founded);
                }
            });

        }

    }

    @action get_project_data(projectID, callback) {
        let copythis = this;
        api_get_projects_by_id({token: this.token, projectID: projectID}, function (res) {
            checkAndRefreshToken(res, copythis, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        copythis.addresses.pickup = res;
                        if (callback) callback(res);
                    } else {
                        copythis.addresses.pickup = [];
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    copythis.get_punti_di_ritiro(callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action get_project_merchant(data, callback) {
        let self = this;
        api_get_project_merchant({idProject: data.idProject, token: self.token}, function (res) {
            
            if (res.project_name) {
                self.project_merchant = res;
                cookies.set('project_type', res.mbu_type_detail, {});
                if (callback) callback(res);
            } else {
                if (callback) callback(res);
            }
        });
    }

    @action setProjectID(projectID) {
        cookies.set('project_id', projectID, {});
        this.project_id = projectID;
    }

    @action change_project_status(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_change_landing_page_data(data, function (res) {
            
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action saveProjectData(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_save_project_data(data, function (res) {
            
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }


    @action getProjectTeams(data, callback) {
        let self = this;
        api_get_project_teams({idProject: data.project_id, token: self.token}, function (res) {
            if (res.length > 0) {
                if (callback) callback(res);
            } else {
                if (callback) callback(res);
            }
        });
    }



    @action save_Added_Athlete(data) {

        // console.log('save_Added_Athlete', data)
    }

    @action clearCalendarData = () => {
        this.selected_calendar_data = [];
        this.calendar_selected = false;
        this.selected_calendar_id = '';
        this.selected_calendar_name = '';
        this.selected_calendar_url = '';
    }

    @action getCalendars(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_get_calendars(data, function (res) {
            
            if (res && res.length > 1) {
                if (callback) callback(res);
            } else {
                if (callback) callback(res);
            }
        });
    }

    @action getCalendarData(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_get_calendar_data(data, function (res) {
            if (res && res.length > 0) {
                // self.calendar_data = res;
                if (callback) callback(res);
            } else {
                if (callback) callback(res);
            }
        });
    }

    @action getCalendarByProjectIdCalendarId(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_get_calendar_data_project_id_calendar_id(data, function (res) {
            if (res && res.length > 0) {
                // self.calendar_data = res;
                if (callback) callback(res);
            } else {
                if (callback) callback(res);
            }
        });
    }

    @action saveEditedCalendarData(data, callback) {
        
        let self = this;
        data['token'] = self.token;
        api_save_edited_calendar_data(data, function (res) {
            if (res) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        })
    }

    @action saveNewCalendar(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_save_calendar_data(data, function (res) {
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(res);
            }
        });
    }

    @action delete_calendar_by_id(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_delete_calendar_by_id(data, function (res) {
            if (res.success === true) {
                self.calendar_data = res;
                if (callback) callback(true);
            } else {
                if (callback) callback(res);
            }
        });
    }

    //
    // @action upload_calendar_data(data, callback) {
    //     const self = this;
    //     const calendar = toJS(self.calendar);
    //     console.log("CALENDAR", calendar);
    //     data['project_id'] = calendar[0].projectID;
    //     data['cal_id'] = calendar[0].idCalendar;
    //     data['cal_name'] = calendar[0].name;
    //     const zip_file = zip_calendar_images(data);
    //     data['file'] = zip_file;
    //
    //     api_upload_calendar_data(data,function (res) {
    //         if (callback) callback(res);
    //     });
    // }


    @action upload_calendar_data(data, callback) {

        const self = this;
        const calendar = toJS(self.calendar);
        

        data['project_id'] = calendar[0].projectID;
        data['cal_id'] = calendar[0].idCalendar;
        data['cal_name'] = calendar[0].name;


        // if(data.january){
        //     const january_photos = [];
        //
        //     if(data.january.photos && data.january.photos.length > 0){
        //         data.january.photos.forEach((photo) => {
        //             january_photos.push(photo.file.name);
        //         });
        //     }
        //     data.january.photo_names = january_photos;
        // }

        // if(data.february){
        //     const february_photos = [];
        //     const february_sponsor_photo = [];
        //     if(data.february.sponsor_1){
        //         february_sponsor_photo.push(data.february.sponsor_1.file.name)
        //     }
        //     if(data.january.sponsor_2){
        //         february_sponsor_photo.push(data.february.sponsor_2.file.name)
        //     }
        //     if(data.february.photos && data.february.photos.length > 0){
        //         data.february.photos.forEach((photo) => {
        //             february_photos.push(photo.file.name);
        //         })
        //     }
        //
        //     data['february_photos'] = february_photos;
        //     data['february_sponsor'] = february_sponsor_photo;
        //     data['february_title'] = data.february.calendar_name;
        //     data['january_description'] = data.february.description;
        //
        //     delete data.february
        // }


        api_upload_calendar_data(data, function (res) {
            if (callback) callback(res);
        });
    }

    @action upload_photo(data, callback) {

        const self = this;
        const calendar = toJS(self.calendar);

        data['project_id'] = calendar[0].projectID;
        data['cal_id'] = calendar[0].idCalendar;
        api_upload_photo(data, function (res) {
            if (callback) callback(res);
        });
    }


    @action get_calendar_landing_page_data_by_url(url, callback) {
        const self = this;
        api_get_calendar_landing_page_data_by_url({url: url}, function (res) {
            if (res) {
                self.calendar = res;
                if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action get_landing_page_data_by_url(url, callback) {

        const self = this;
        api_get_landing_page_data_by_url({url: url}, function (res) {
            if (res) {
                self.calendar = res;
                if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action get_project_metadata(data, callback) {
        let self = this;
        
        api_get_metadata_by_projectID({project_id: self.project_id, token: self.token}, function (res) {
        
            checkAndRefreshToken(res, self, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
        
                        // self.shop_orders = res.results;
                        // self.projectMetadata = res;
                        self.shopOrders_search_results = res;
                        if (callback) callback(res);
                    } else {
        
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    self.get_shop_orders(data, callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action get_project_configuration_data(data, callback) {
        let self = this;
        api_get_project_configuration_data({project_id: self.project_id, token: self.token}, function (res) {
            if (res) {
                cookies.set('landing_page_status', res[0].landing_page_enabled, {});
                if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action look_for_project_data(data, callback) {
        let self = this;
        api_get_data_sessione_scatti({project_id: self.project_id, token: self.token}, function (res) {
            if (res && res.length > 0) {
                cookies.set('upload_closed', true);
                if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action get_data_sessione_scatti(data, callback) {
        const self = this;
        api_get_data_sessione_scatti(data, function (res) {
            if (res) {
                
                self.sessione_scatti_search_results = [];
                self.sessione_scatti_search_results = res;
                if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action get_last_data_sessione_scatti(data, callback) {
        
        api_get_last_data_sessione_scatti(data, function (res) {
            if (res) {
                if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action update_download_date(data, callback) {
        api_update_download_data(data, function (res) {
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action sendDataToReferents(data, callback) {
        let self = this;
        data['token'] = self.token;
        api_send_data_to_referents(data, function (res) {
            if (res.success === true) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    //=====================================
    //======= API UTIL FUNCTIONS ==========
    //=====================================

    @action setStoreData(projectID) {
        
        cookies.set('project_id', projectID, {});
        this.project_id = projectID;
    }

    @action search_customers(data, callback) {
        let copythis = this;
        const key = data && data.key ? data.key : this.options_users_search.key;
        const page = data && data.page ? data.page : 0;
        const limit = data && data.limit ? data.limit : this.options_users_search.limit;
        const sort = data && data.sort ? data.sort : '';
        const order = data && data.order ? data.order : '';
        const filter = data && data.filter ? data.filter : '';

        api_search_users({
            token: this.token,
            key: key,
            page: page,
            limit: limit,
            sort: sort,
            order: order,
            filter: filter,
            employee: 0,
            guest: 1
        }, function (res) {
            checkAndRefreshToken(res, copythis, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        if (callback) callback(res);
                        copythis.users_employee_results = res;
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    copythis.search_users(data, callback);
                } else {
                    // console.log('error');
                }
            });

        });
    }

    @action set_code(code) {
        let self = this;
        const minutes = 3600;
        let expires = new Date();
        expires.setTime(expires.getTime() + (minutes * 60 * 1000));
        cookies.set('code', code, {path: '/', domain: self.store.domain, expires: expires});
        self.code = code;
    }

    @action get_user_addresses(is_billing, callback) {
        let copythis = this;
        api_get_user_addresses({token: this.token, is_billing: is_billing}, function (res) {
            if (res) {
                res = res.filter((addr) => addr.country === LANGUAGES_COUNTRY[copythis.lang]);
                if (is_billing) copythis.addresses.billing = res;
                else copythis.addresses.shipment = res;
                if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action add_user_address(data, callback) {
        let copythis = this;
        data.token = this.token;
        api_add_user_address(data, function (res) {
            checkAndRefreshToken(res, copythis, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        if (callback) callback(res);
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    copythis.add_user_address(data, callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action update_user_address(data, callback) {
        var copythis = this;
        data.token = this.token;
        api_update_user_address(data, function (res) {
            checkAndRefreshToken(res, copythis, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        if (callback) callback(res);
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    copythis.update_user_address(data, callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action delete_user_address(data, callback) {
        
        let copythis = this;
        data.token = this.token;
        api_delete_user_address(data, function (res) {
            checkAndRefreshToken(res, copythis, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        if (callback) callback(res);
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    copythis.delete_user_address(data, callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action set_default_user_address(data, callback) {
        let copythis = this;
        data.token = this.token;
        data.is_billing = data.is_billing;
        api_set_default_user_address(data, function (res) {
            checkAndRefreshToken(res, copythis, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        if (callback) callback(res);
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    copythis.set_default_user_address(data, callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action get_punti_di_ritiro(is_pickup_point, callback) {
        let copythis = this;
        api_get_user_pickup_addresses({token: this.token, is_pickup_point: is_pickup_point}, function (res) {
            checkAndRefreshToken(res, copythis, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        copythis.addresses.pickup = res;
                        if (callback) callback(res);
                    } else {
                        copythis.addresses.pickup = [];
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    copythis.get_punti_di_ritiro(callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action update_user(data, callback) {
        data.token = this.token;
        api_update_user(data, function (res) {
            if (callback) callback(res);
        });
    }

    @action update_user_phone(data, callback) {
        let self = this;
        api_update_user_phone({token: this.token, phone: data.phone}, function (res) {
            if (res) {
                self.phone = data.phone;
                cookies.set('phone', data.phone, {path: '/', domain: '.' + self.hostname});
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action update_user_email(data, callback) {
        let self = this;
        const DEFAULT_TEXT = toJS(self.DEFAULT_TEXT);
        const params = {
            token: this.token,
            new_email: data.new_email,
            password: data.password,
            hello: DEFAULT_TEXT.greeting,
            welcome: DEFAULT_TEXT.email_welcome,
            thank: DEFAULT_TEXT.email_thank,
            update: DEFAULT_TEXT.password_update,
            modify_click: DEFAULT_TEXT.update_email,
            modify: DEFAULT_TEXT.update_email_click
        };
        api_update_user_email(params, function (res) {
            if (callback) callback(res);
        });
    }

    @action get_orders(data, callback) {
        let self = this;
        api_get_orders({token: this.token, project_id: this.store.project_id}, function (res) {
            if (res) {
                self.orders = res;
                if (callback) callback(res);
            }
        });
    }

    @action get_myshop_orders(data, callback) {
        let self = this;
        api_get_orders({project_id: self.project_id, token: self.token}, function (res) {
            
            checkAndRefreshToken(res, self, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        self.myshopOrders_search_results = res;
                        if (callback) callback(res);
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    self.get_myshop_orders(data, callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action get_margins_and_royalties(data, callback) {
        let self = this;
        // let key = data && data.key ? data.key : this.options_shopOrders_search.key;
        // let page = data && data.page ? data.page : this.options_shopOrders_search.page;
        // let limit = data && data.limit ? data.limit : this.options_shopOrders_search.limit;

        // api_get_orders_by_shop ({ project_id: self.project_id, token:this.token, key:key, page:page, limit:limit }, function(res){
        api_get_stack_by_user({token: self.token}, function (res) {
            
            checkAndRefreshToken(res, self, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        self.marginsAndRoyalties_search_results = res;
                        if (callback) callback(res);
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    self.get_margins_and_royalties(data, callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action get_user_coupons(data, callback) {
        let self = this;
        api_get_coupon_by_user({token: self.token}, function (res) {
            
            checkAndRefreshToken(res, self, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        self.coupons_search_results = res;
                        if (callback) callback(res);
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    self.get_user_coupons(data, callback);
                } else {
                    // console.log('error');
                }
            });
        });
    }

    @action add_coupon(data, callback) {
        let self = this;
        api_create_Coupon({
            token: this.token,
            coupon_value: data.coupon_value,
            coupon_type: data.coupon_type,
            idProject: data.idProject
        }, function (res) {
            checkAndRefreshToken(res, self, function (checked, refreshed) {
                if (checked && !refreshed) {
                    if (res) {
                        if (callback) callback(true);
                    } else {
                        if (callback) callback(false);
                    }
                } else if (checked && refreshed) {
                    // self.add_shipment(data, callback);
                } else {
                    // console.log('error');
                }
            });

        });
    }

    @action get_all_shipments(callback) {
        let self = this;
        api_search_shipments({
            limit: 1000,
            order: 'asc',
            page: 1,
            key: "",
            sort: "asc",
            filter: "",
            token: this.token
        }, function (res) {
            if (res) {
                self.shipments = res;
                
                if (callback) callback(res);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action swicth_active_or_disable_user(data, callback) {
        api_swicth_active_or_disable_user({
            token: this.token,
            user_id: data.user_id,
            active: data.active
        }, function (res) {
            if (res) {
                if (callback) callback(true);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action delete_user(callback) {
        //non farlo
    }

    @action recover_password(email, callback) {
        let copythis = this;
        const DEFAULT_TEXT = toJS(this.DEFAULT_TEXT);
        
        const params = {
            'email': email,
            thank: DEFAULT_TEXT.email_thank,
            update: DEFAULT_TEXT.password_update,
            hello: DEFAULT_TEXT.my_account_hello,
            modify_click: DEFAULT_TEXT.modify_click,
            click: DEFAULT_TEXT.email_click_password,
            modify: DEFAULT_TEXT.modify
        };
        if (this.password_recovered === 0) {
            api_recover_password(params, function (res) {
                if (res.id) {
                    const minutes = 60;
                    let expires = new Date();
                    expires.setTime(expires.getTime() + (minutes * 60 * 1000));
                    cookies.set('password_recovered', 1, {
                        path: '/',
                        domain: '.' + copythis.hostname,
                        expires: expires
                    });
                    copythis.password_recovered = 1;
                    if (callback) callback(res);
                } else {
                    if (callback) callback(false);
                }
            });
        } else {
            if (callback) callback(false);
        }
    }

    @action me(data, callback, retry = true) {
        let copythis = this;
        if (retry) {
            api_me({token: this.token, permissions: data.permissions}, function (res) {
                checkAndRefreshToken(res, copythis, function (checked, refreshed) {
                    if (checked && !refreshed) {
                        if (res) {
                            if (res.email) cookies.set('email', res.email, {
                                path: '/',
                                domain: '.' + copythis.hostname
                            });

                            if (res.id) cookies.set('user_id', res.id, {
                                path: '/',
                                domain: '.' + copythis.hostname
                            });

                            if (res.verified) cookies.set('verified', res.verified, {
                                path: '/',
                                domain: '.' + copythis.hostname
                            });

                            if (res.email) copythis.email = res.email;
                            if (res.id) copythis.user_id = res.id;
                            if (res.name) copythis.name = res.name;
                            if (res.surname) copythis.surname = res.surname;
                            if (res.phone) copythis.phone = res.phone;
                            if (res.verified) copythis.verified = res.verified;
                            if (res.permissions) copythis.permissions = res.permissions;
                            copythis.all_user_data = res;

                            const user_has_permissions = res['permissions'].filter(obj => {
                                return obj.name === 'photoselfie::access'
                            });

                            if (user_has_permissions.length > 0) {
                                copythis.user_has_permission_to_access_ps = true;
                            }
                            if (callback) callback(res);
                        } else {
                            if (callback) callback(false);
                        }
                    } else if (checked && refreshed) {
                        copythis.me(data, callback);
                    } else {
                        // console.log('error');
                    }
                });
            });
        } else {
            api_me({token: this.token, permissions: data.permissions}, function (res) {
                if (res && !res.auth && res.auth !== false) {
                    if (res.email) cookies.set('email', res.email, {path: '/', domain: '.' + copythis.hostname});
                    if (res.id) cookies.set('user_id', res.id, {path: '/', domain: '.' + copythis.hostname});
                    if (res.verified) cookies.set('verified', res.verified, {
                        path: '/',
                        domain: '.' + copythis.hostname
                    });
                    if (res.email) copythis.email = res.email;
                    if (res.id) copythis.user_id = res.id;
                    if (res.name) copythis.name = res.name;
                    if (res.surname) copythis.surname = res.surname;
                    if (res.phone) copythis.phone = res.phone;
                    if (res.verified) copythis.verified = res.verified;
                    if (res.permissions) copythis.permissions = res.permissions;
                    if (callback) callback(res);
                } else {
                    //clearCookies(copythis); // TODO - user logged
                    if (callback) callback(false);
                }
            });
        }

    }

    @action login_as_user(email, callback) {
        let self = this;
        let old_cookies = cookies.getAll();
        api_login_as_user({token: this.token, email: email}, function (res) {
            if (res) {
                cookies.set('old_cookies', JSON.stringify(old_cookies), {path: '/', domain: '.' + self.hostname});
                localStorage.clear();
                afterLogin(res, self, callback);
            } else {
                if (callback) callback(false);
            }
        });
    }

    @action formatDate(date) {
        return formatDate(date);
    }

    @action formatValue(value) {
        return formatValue(value);
    }

    @action return_to_my_user() {
        const self = this;
        const old_cookies = Object.assign({}, cookies.get('old_cookies'));
        cookies.remove('old_cookies', {path: '/', domain: '.' + self.hostname});
        localStorage.clear();
        afterLogin(old_cookies, self, function (res) {
            window.location.reload();
        });
    }

    @action getColors(mystore = false) {
        let colors = {
            primary: this.getMaterialColor(this.store.colors.primary),
            secondary: this.getMaterialColor(this.store.colors.secondary)
        };
        if (this.store.colors_shop && mystore)
            colors = {
                primary: this.getMaterialColor(this.store.colors_shop.primary),
                secondary: this.getMaterialColor(this.store.colors_shop.secondary)
            };
        return colors;
    }

}

function afterLogin(res, self, callback) {
    if (res.token) {
        cookies.set('email', res.email, {path: '/', domain: '.' + self.hostname});
        // cookies.set('user_id', res.id, { path: '/' , domain:'.'+self.hostname});
        cookies.set('token', res.token, {path: '/', domain: '.' + self.hostname});
        // cookies.set('refresh_token', res.refresh_token, { path: '/' , domain:'.'+self.hostname});
        cookies.set('verified', res.verified, {path: '/', domain: '.' + self.hostname});
        // cookies.set('project_id', res.project_id, { path: '/' , domain:'.'+self.hostname});

        self.email = res.email;
        // self.user_id = res.id;
        self.token = res.token;
        // self.refresh_token = res.refresh_token;
        self.verified = res.verified;
        self.project_id = res.project_id;

        if (res.refresh_token) {
            cookies.set('refresh_token', res.refresh_token, {path: '/', domain: '.' + self.hostname});
            self.refresh_token = res.refresh_token;
        } else {
            cookies.set('refresh_token', "", {path: '/', domain: '.' + self.hostname});
            self.refresh_token = "";
        }

        if (res.id) {
            self.user_id = res.id;
            cookies.set('user_id', res.id, {path: '/', domain: '.' + self.hostname});
        }

        if (res.name) {
            self.name = res.name;
            cookies.set('name', res.name, {path: '/', domain: '.' + self.hostname});
        }
        if (callback) callback(res);

    } else {
        if (callback) callback(false);
    }
}

function checkAndRefreshToken(res, copythis, callback) {
    // let data = {id: copythis.user_id, refresh_token: copythis.refresh_token};
    if (res && res.auth === false) {
        
        clearCookies(copythis);
        window.location.reload();
    } else {
        if (!res || (res.error && res.error === "not permitted")) {
        }
        if (callback) callback(true, false);
    }
}

function clearCookies(copythis) {
    
    cookies.remove('token', {path: '/', domain: '.' + copythis.hostname});
    cookies.remove('refresh_token', {path: '/', domain: '.' + copythis.hostname});
    cookies.remove('user_id', {path: '/', domain: '.' + copythis.hostname});
    cookies.remove('email', {path: '/', domain: '.' + copythis.hostname});
    cookies.remove('upload_closed');
    cookies.remove('project_type');
    cookies.remove('landing_page_status');
    cookies.remove('token');
    cookies.remove('project_id');
    cookies.remove('app_lang');
    localStorage.removeItem('session_closed');
    // cookies.remove('project_id', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('verified', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('password_recovered', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('code', {path: '/', domain: copythis.store.domain});
    // cookies.remove('old_cookies', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('name', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('surname', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('phone', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('project_id', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('data_ordine_iniziale', {path: '/', domain: '.' + copythis.hostname});
    // cookies.remove('data_ordine_finale', {path: '/', domain: '.' + copythis.hostname});

    // copythis.email = '';
    // copythis.token = false;
    // copythis.refresh_token = false;
    // copythis.user_id = false;
    // copythis.verified = 0;
    // copythis.project_id = '';
    // copythis.password_recovered = false;
    // // copythis.code = false;
    // copythis.old_cookies = false;
    // copythis.name = false;
    // copythis.surname = false;
    // copythis.phone = false;
}

function formatDate(input) {
    let datePart = input.match(/\d+/g),
        year = datePart[0],
        month = datePart[1], day = datePart[2];

    return day + '-' + month + '-' + year;
}

function formatValue(value) {
    return value.toLocaleString('it', {minimumFractionDigits: 2});
}

// function zip_calendar_images(files){
//     console.log("FILES", files.january);
//     const zip = require('jszip')();
//     files.january.photos.forEach((file) => {
//         zip.file(file.file.name, file.file);
//     });
//     zip.generateAsync({type: "blob"}).then(content => {
//         console.log("ZIP", content);
//         return content;
//     });
// }

export function api_swicth_active_or_disable_user(data, callback) {
    fetch(API_URL + '/user/active/' + data.active + "/" + data.user_id, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + data.token,
        },
    }).then(function (res) {
        if (res.status === 200) {
            return res.json();
        } else {
            if (callback) callback(false);
            return false;
        }
    }).then(function (result) {
        if (result) {
            if (callback) callback(result);
        } else {
            if (callback) callback(false);
        }
    }).catch(function (error) {
        if (callback) callback(false);
    });
}



// WEBPACK FOOTER //
// ./src/stores/AppState.js